import React from 'react';
import { Modal, Space } from 'antd';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy, useSortable } from '@dnd-kit/sortable';

const SortItem = ({ item, valueLabelMap }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: String(item) });

  const itemLabel = valueLabelMap?.get(String(item)) || item;
  const style = {
    border: '1px solid #d9d9d9',
    borderRadius: 999,
    padding: '4px 10px',
    cursor: 'grab',
    background: isDragging ? '#f5f5f5' : '#fff',
    userSelect: 'none',
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '20px',
    fontSize: 13,
    whiteSpace: 'nowrap',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {itemLabel}
    </div>
  );
};

const SortValueModal = ({
  open,
  draftOrder = [],
  valueLabelMap,
  onCancel,
  onApply,
  onReorder,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 6 },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!active?.id || !over?.id || active.id === over.id) return;
    onReorder(active.id, over.id);
  };

  return (
    <Modal
      title='Sắp xếp giá trị thuộc tính'
      open={open}
      onCancel={onCancel}
      onOk={onApply}
      okText='Áp dụng'
      cancelText='Hủy'
    >
      <Space direction='vertical' size={8} style={{ width: '100%' }}>
        <div style={{ color: '#8c8c8c' }}>Kéo thả để đổi thứ tự giá trị</div>
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={draftOrder.map((x) => String(x))} strategy={rectSortingStrategy}>
            <div
              style={{
                width: '100%',
                minHeight: 120,
                border: '1px dashed #d9d9d9',
                borderRadius: 8,
                padding: 10,
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                gap: 8,
              }}
            >
              {draftOrder.map((item) => (
                <SortItem key={String(item)} item={item} valueLabelMap={valueLabelMap} />
              ))}
            </div>
          </SortableContext>
        </DndContext>
        {draftOrder.length === 0 && <div style={{ color: '#8c8c8c' }}>Chưa có giá trị nào để sắp xếp</div>}
      </Space>
    </Modal>
  );
};

export default SortValueModal;
